import { useTranslation } from "react-i18next";
import CountryCode from "components/select/countryCode";
import Select from "components/select";
import Button from "components/button/default";
import { dateFormat, modalControl } from "util/commAction";
import { IMemInf } from "interface/user";
import { monthOptionNm } from "util/option";
import { RefObject } from "react";
import MailCheck from "./modalInner/mailchk";
import Input from "components/updateForm/input";
import Radio from "components/updateForm/radio";
import Checkbox from "components/updateForm/checkbox";
import "./userInf.scss";

type IProps = {
  userInf: IMemInf | null;
  formRef: RefObject<HTMLFormElement | null>;
  handleUpdateInf(): void;
  handleWithdrawal(): void;
};

export default function UserInf({
  userInf,
  formRef,
  handleUpdateInf,
  handleWithdrawal,
}: IProps) {
  const { t } = useTranslation();

  const year = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => {
    return {
      ko: year - i + "년",
      en: year - i,
      value: year - i,
      code: year - i,
    };
  });

  const days = Array.from({ length: 31 }, (_, i) => {
    return {
      ko: i + 1 + "일",
      en: i + 1,
      value: i + 1,
      code: String(i + 1).padStart(2, "0"),
    };
  });

  return (
    <div className={"user-inf"}>
      <div className="">
        <h2 className="text-[24px]">{t("ttl_inf_mpg")}</h2>
        <sub>{t("dscrp_rqr_mpg")}</sub>
      </div>
      <div>
        <ul className="mt-[2.5rem] flex flex-col gap-[2rem]">
          <li>
            <label htmlFor="dot">{t("lbl_eml_id_mpg")}</label>
            <h4>{userInf?.emlId}</h4>
          </li>
          <li>
            <label htmlFor="dot">
              {t("lbl_id_nm_mpg")}({t("lbl_id_nm_dscrp_mpg")})
            </label>
            <h4>{userInf?.memNo}</h4>
          </li>
          <li>
            <label htmlFor="dot">{t("lbl_pss_cmm")}</label>
            <Button
              text={t("btn_rst_pss_cmm")}
              styels="radius-4 h-48 w-[200px]"
              onClick={() => {
                modalControl({
                  isOpen: true,
                  disabled: true,
                  styles: "w-full max-w-[386px]",
                  chckBtn: false,
                  inner: <MailCheck />,
                  click: () => {
                    alert("비밀번호 체크");
                  },
                });
              }}
            />
          </li>
        </ul>
        <form id="" className="mt-[1.5rem] " ref={formRef}>
          <ul className="flex flex-col gap-[1.5rem]">
            <li>
              <label htmlFor="dot">{t("lbl_nm_cmm")}</label>
              <div className="flex gap-2">
                <Input
                  name={"memSurnm"}
                  defaultValue={userInf?.memSurnm ?? ""}
                />

                <Input
                  name={"memFstnm"}
                  defaultValue={userInf?.memFstnm ?? ""}
                />
              </div>
            </li>
            <li>
              <label htmlFor="dot">{t("lbl_ph_nm_cmm")}</label>
              <div className="flex gap-2">
                <CountryCode styles="w-[168px]" option={userInf?.mobCntyCd} />
                <Input name={"memMobNo"} defaultValue={userInf?.mobNo ?? ""} />
              </div>
            </li>
          </ul>
          <ul className="flex flex-col gap-6">
            <li>
              <label htmlFor="">{t("lbl_brth_cmm")}</label>
              <div className="flex gap-2">
                <Select
                  list={years}
                  defaultValue={undefined}
                  styles="w-1/2 md:w-full"
                  option={dateFormat(userInf?.lawBird ?? "").split("-")[0]}
                  name={"bird-year"}
                />
                <Select
                  list={monthOptionNm}
                  defaultValue={undefined}
                  styles="w-1/4 md:w-full"
                  option={Number(
                    dateFormat(userInf?.lawBird ?? "").split("-")[1]
                  ).toString()}
                  name={"bird-month"}
                />
                <Select
                  list={days}
                  defaultValue={undefined}
                  styles="w-1/4 md:w-full"
                  option={Number(
                    dateFormat(userInf?.lawBird ?? "").split("-")[2]
                  ).toString()}
                  name={"bird-day"}
                />
              </div>
            </li>
            <li>
              <label htmlFor="">{t("lbl_gnd_cmm")}</label>
              <ul className="flex gap-8">
                <li>
                  <Radio
                    name={"memGendCd"}
                    id={"M"}
                    label={t("rd_lbl_m_cmm")}
                    defaultChecked={userInf?.gendCd === "M"}
                  />
                </li>
                <li>
                  <Radio
                    name={"memGendCd"}
                    id={"F"}
                    label={t("rd_lbl_f_cmm")}
                    // defaultChecked={userInf?.gendCd === "F"}
                    defaultChecked={true}
                  />
                </li>
                <li>
                  <Radio
                    name={"memGendCd"}
                    id={"A"}
                    label={t("rd_lbl_nt_mpg")}
                    defaultChecked={userInf?.gendCd === ""}
                  />
                </li>
              </ul>
            </li>
            <li>
              <label htmlFor="">{t("lbl_arr_mpg")}</label>
              <ul className="flex gap-8">
                <li>
                  <Checkbox
                    name={"all"}
                    id={"all"}
                    label={t("rd_lbl_all_mpg")}
                    defaultChecked={
                      userInf?.mktEmlAgrYn === "Y" &&
                      userInf?.mktSnsAgrYn === "Y"
                    }
                  />
                </li>
                <li>
                  <Checkbox
                    name={"mktEmlAgrYn"}
                    id={"mktEmlAgrYn"}
                    label={t("rd_lbl_eml_mpg")}
                    defaultChecked={userInf?.mktEmlAgrYn === "Y"}
                  />
                </li>
                <li>
                  <Checkbox
                    name={"mktSnsAgrYn"}
                    id={"mktSnsAgrYn"}
                    label={"SNS"}
                    defaultChecked={userInf?.mktSnsAgrYn === "Y"}
                  />
                </li>
              </ul>
            </li>
          </ul>
        </form>
        <div className="flex justify-between ">
          <button className="text-gray-500" onClick={handleWithdrawal}>
            {t("btn_wthdrw_mpg")}
          </button>
          <div className="flex gap-2">
            <Button
              text={t("btn_ccl_cmm")}
              styels="bg-white radius-4 w-[108px] h-48"
              onClick={() => {}}
            />
            <Button
              text={t("btn_sv_cmm")}
              styels="w-[108px] radius-4 h-48"
              onClick={handleUpdateInf}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
